module.exports = __webpack_public_path__ + "static/media/close-white.a77fde3f.svg";